import axios, { AxiosResponse } from 'axios';

class ApiReceiver {
  public async getData<T = never>(path: string): Promise<T> {
    const response: AxiosResponse = await axios.get<T>(path);

    return response.data;
  }

  public async putData<T = never>(path, requestBody): Promise<T> {
    const response: AxiosResponse = await axios.put<T>(path, requestBody);

    return response.data;
  }

  public async postData<T = never>(path, requestBody): Promise<T> {
    const response: AxiosResponse = await axios.post<T>(path, requestBody);

    return response.data;
  }
}

export default ApiReceiver;
